import "./styles.less";

import React, { ReactElement, useContext } from "react";

import { FormButton } from "./FormButton/web";
import { ButtonsLeadsSource, ModalState } from "../TextForm/type";

import dynamic from "next/dynamic";
import { useTheme } from "shared-components/Styles/ThemeHook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { FormCallToActions, useContactModal } from "shared-components/Contexts/ContactModal/context";

//@ts-ignore
const WhatsappButton = dynamic(
	() => import("./WhatsappButton/web").then(mod => mod.WhatsappButton),
	{ ssr: false }
);
const PhoneButton = dynamic(() => import("./PhoneButton/web").then(mod => mod.PhoneButton), {
	ssr: false,
});

export const LeadButtons = ({
	id,
	children = null,
	disabled = false,
	isInListing = false,
	queryRouter,
	onWpClick,
	forceState = ModalState.DEFAULT,
	idealFilters,
	isProject,
	owner,
	seller,
	projectId,
	setDataModal,
	hasAcceptedTerms = true,
	onTermsError,
	onBeforeAction,
	source = "",
	propertyLink,
	ctaToShow
}: {
	id: any;
	children?: ReactElement;
	disabled?: boolean;
	isInListing?: boolean;
	queryRouter?: string;
	onWpClick?: () => void;
	forceState?: ModalState;
	idealFilters?: any;
	isProject?: boolean;
	owner?: any;
	seller?: any;
	projectId?: number;
	setDataModal?: any;
	hasAcceptedTerms?: boolean;
	onTermsError?: (e) => void;
	onBeforeAction?: (e, cta: "phone" | "whatsapp") => boolean;
	source?: ButtonsLeadsSource;
	propertyLink?: string;
	ctaToShow: FormCallToActions
}) => {
	const {theme} = useTheme();
	const { site_name, country_code } = useContext(ConfigStateContext);
	const { openContactModal, closeContactModal } = useContactModal();
	const hasPhone = seller ? seller?.masked_phone : owner?.masked_phone;
	const showContactModal = source === "card";
	const defaultMessage = `Hola, vi esta propiedad en ${site_name} y me interesa recibir más información. ¡Muchas gracias!`;

	const handleOpenContactModal = ({ ctaButtons } : { ctaButtons: FormCallToActions }) => {		
		openContactModal({
			id,
			owner,
			isProject: isProject ?? false,
			projectId,
			defaultMessage,
			source: source,
			propertyLink,
			ctaToShow: ctaButtons
		});
	}

	return (
		<div className={`property-lead-button ${country_code !== "CO" ? "inline" : "grid" } ${isInListing ? "in-listing" : "not-listing"}`} style={isInListing ? { textAlign: "right" } : null}>
			{ctaToShow && ctaToShow.contact ? 
				children ? (
					<div>{children}</div>
				) : (
					<div><FormButton
						idealFilters={idealFilters ?? undefined}
						callback={handleOpenContactModal}
					/></div>
				) 
			: null}

			{hasPhone && (ctaToShow && ctaToShow.phone) ? (
				<div>
					<PhoneButton
						id={id}
						type={"callButton"}
						forceState={forceState}
						disabled={disabled}
						queryRouter={queryRouter}
						owner={owner}
						isProject={isProject}
						hasAcceptedTerms={hasAcceptedTerms}
						onTermsError={onTermsError}
						onBeforeAction={onBeforeAction}
						color={theme.colors.primaryColor}
						callback={showContactModal ? handleOpenContactModal : null}
						handleCloseContactModal={closeContactModal}
						source={source}
					/>
				</div>
			): null}

			{owner && owner.has_whatsapp && (ctaToShow && ctaToShow.whatsapp) ? (
				<div>
					<WhatsappButton
						id={id}
						setDataModal={setDataModal}
						disabled={disabled}
						forceState={forceState}
						onWpClick={onWpClick}
						queryRouter={queryRouter}
						owner={owner}
						isProject={isProject}
						hasAcceptedTerms={hasAcceptedTerms}
						onTermsError={onTermsError}
						onBeforeAction={onBeforeAction}
						callback={showContactModal ? handleOpenContactModal : null}
						handleCloseContactModal={closeContactModal}
						source={source}
						propertyLink={propertyLink}
					/>
				</div>
			) : null}
		</div>
	);
};
